import { DateTime } from 'luxon'

export function getGreatestDateTime(
  ...datetimes: (DateTime | undefined)[]
): DateTime | undefined {
  return datetimes
    .filter((dt): dt is DateTime => dt !== undefined)
    .reduce((greatest, current) => {
      if (!greatest) return current
      if (current > greatest) return current
      return greatest
    })
}

export function dateTime(date: Date | undefined): DateTime | undefined {
  return date ? DateTime.fromJSDate(date) : undefined
}

export function compareOptionalDates(
  a: DateTime | undefined,
  b: DateTime | undefined
): number {
  if (!a && !b) return 0
  if (!a) return -1
  if (!b) return 1
  return a.toMillis() - b.toMillis()
}
